module.exports = __webpack_public_path__ + "static/avatars2-6d3a662057e387dbba2ca02576d32d88.jpg";